/**
 * Demo video content — HRD-9/HRD-17. The Demo hub's "player" used to be a
 * static poster image with a dead Play button; no media URL existed
 * anywhere in the app or backend. One admin-editable entry per product
 * kind (a hosted video URL — CDN/YouTube/direct MP4, not uploaded here).
 *
 *   GET  /demo-media              — public, mobile-facing: active entries only
 *   GET  /admin/demo-media        — admin: every entry, including inactive
 *   POST /admin/demo-media        — admin: create/replace an entry for a product kind
 *   PATCH /admin/demo-media/:id   — admin: update
 *   DELETE /admin/demo-media/:id  — admin: delete
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
export const DemoProductKindSchema = z.enum(['stair', 'ceiling', 'lift']);
export const DemoMediaEntrySchema = z.object({
    id: UuidSchema,
    productKind: DemoProductKindSchema,
    videoUrl: z.string().url(),
    active: z.boolean(),
});
// ── GET /demo-media ──────────────────────────────────────────────────────
export const DemoMediaListResponse = z.object({
    entries: z.array(DemoMediaEntrySchema),
});
// ── GET /admin/demo-media ────────────────────────────────────────────────
export const AdminDemoMediaListResponse = z.object({
    entries: z.array(DemoMediaEntrySchema),
});
// ── POST /admin/demo-media ───────────────────────────────────────────────
export const DemoMediaUpsertBody = z.object({
    productKind: DemoProductKindSchema,
    videoUrl: z.string().url(),
    active: z.boolean().default(true),
});
// ── PATCH /admin/demo-media/:id ──────────────────────────────────────────
export const DemoMediaUpdateBody = z.object({
    videoUrl: z.string().url().optional(),
    active: z.boolean().optional(),
});
//# sourceMappingURL=demo-media.js.map